import { Typography } from '@mui/material';
import { useTranslation } from '../hooks/useTranslation';
import Sheet from 'react-modal-sheet';
import Image1 from '../assets/Group 1000005554.png';
import Image2 from '../assets/Group 1000005554@2x.png';
import Image3 from '../assets/Group 1000005554@3x.png';
import { SecondaryButton } from './SecondaryButton';

export const HowGetCodeSheet = (props) => {
  const { open, setOpen } = props;
  const { t } = useTranslation();
  return (
    <Sheet
      style={{
        maxWidth: '430px',
        margin: '0 auto',
        zIndex: 9999,
      }}
      isOpen={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Sheet.Container
        style={{
          maxHeight: '430px',

          //padding: '16px',
        }}
      >
        <Sheet.Header style={{ height: '0px', Opacity: 0, display: 'none' }} />
        <Sheet.Content
          style={{
            padding: '16px',
            paddingBottom: '23px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
          }}
        >
          <Typography
            sx={{ fontSize: '24px', fontWeight: '700', lineHeight: '28.845px' }}
          >
            {t('submitPage.how.title')}
          </Typography>
          <Typography
            sx={{ fontSize: '12px', fontWeight: '500', marginTop: '12px' }}
          >
            {t('submitPage.how.description')}
          </Typography>
          <div
            style={{
              marginTop: '12px',
              width: '100%',
              height: '242px',
              borderRadius: '10px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src={Image1}
              alt="src"
              srcSet={`
       ${Image1} 1x,
       ${Image2} 2x,
       ${Image3} 3x
     `}
              style={{ maxHeight: '242px', objectFit: 'contain' }}
            />
          </div>
          <SecondaryButton
            sx={{ marginTop: '20px' }}
            onClick={() => setOpen(false)}
          >
            {t('close')}
          </SecondaryButton>
        </Sheet.Content>
      </Sheet.Container>

      <Sheet.Backdrop />
    </Sheet>
  );
};
